var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Studentfile/StudentfileIndex.vue
// module id = 1214
// module chunks = 0